import React, { FC, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { SCUIUpdateRoleDialogContent } from '../SCUIUpdateRoleDialogContent/SCUIUpdateRoleDialogContent';
import { RoleModel, UpdateRoleRequest } from '../../../types/models/role.models';
import { OperatorCommand } from '../../../services/command';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

interface IProps {
    selectedRole?: RoleModel;
    open?: boolean;
    onClose?: () => void;
    refresh?: () => void;
}

export const SCUIUpdateRoleDialog: FC<IProps> = ({ selectedRole, open = false, onClose, refresh }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const handleUpdateRole = async (roleData: UpdateRoleRequest) => {
        setIsLoading(true);
        try {
            const response = await OperatorCommand.PutUpdateRole(roleData);

            if (response === true) {
                Swal.fire({
                    title: t('general.success'),
                    text: t('authorizationManagement.roleUpdated'),
                    icon: 'success',
                    timer: 1000,
                    showConfirmButton: false,
                });

                if (refresh) {
                    refresh();
                }
                setTimeout(() => {
                    if (onClose) {
                        onClose();
                    }
                }, 1000);
            } else if (response === false) {
                Swal.fire({
                    title: t('general.warning'),
                    text: t('authorizationManagement.roleNotUpdated'),
                    icon: 'warning',
                    timer: 1500,
                    showConfirmButton: false,
                });

                setTimeout(() => {
                    if (onClose) {
                        onClose();
                    }
                }, 1500);
            }
        } catch (error) {
            console.error('Error updating role:', error);
            // Error: 1.5 saniyede kapan
            Swal.fire({
                title: t('general.error'),
                text: t('authorizationManagement.errorUpdatingRole'),
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
            });

            setTimeout(() => {
                if (onClose) {
                    onClose();
                }
            }, 1500);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={!isLoading ? onClose : undefined} maxWidth="sm" fullWidth>
            <DialogTitle>{t('authorizationManagement.editRole')}</DialogTitle>
            <SCUIUpdateRoleDialogContent
                selectedRole={selectedRole}
                onUpdateRole={handleUpdateRole}
                onCloseUpdateRole={!isLoading ? onClose : undefined}
            />
        </Dialog>
    );
};
